export default __webpack_public_path__ + "static/media/House-contact.6408159f.png";